import {
  Task,
  taskZod,
  TasksResp,
  tasksRespZod,
} from 'packages/lib/api/annotations/contract/task';
import {
  TaskGroup,
  taskGroupZod,
} from 'packages/lib/api/annotations/contract/task-group';
import { annotationsApi } from 'packages/lib/api/annotations/rest';
import useSWR, { SWRResponse } from 'swr';

type Enabled = { enabled?: boolean };

export function useTaskByToken(
  taskToken: string | null | undefined,
  { enabled = true }: Enabled = {}
): SWRResponse<Task> {
  return useSWR(
    enabled && taskToken ? `/tasks/${taskToken}` : null,
    (apiPath: string) => annotationsApi.get(apiPath, taskZod.parse)
  );
}

export function useTaskGroupByToken(
  taskGroupToken: string | null | undefined,
  { enabled = true }: Enabled = {}
): SWRResponse<TaskGroup> {
  return useSWR(
    enabled && taskGroupToken ? `/task-groups/${taskGroupToken}` : null,
    (apiPath: string) => annotationsApi.get(apiPath, taskGroupZod.parse)
  );
}

type UseTaskParams = { enabled?: boolean; query?: URLSearchParams };

export function useTasksAPI({
  enabled = true,
  query,
}: UseTaskParams = {}): SWRResponse<TasksResp> {
  const queryString = query?.toString();
  const endpoint = queryString ? `/tasks?${queryString}` : '/tasks';

  return useSWR(enabled ? endpoint : null, (endpoint: string) =>
    annotationsApi.get(endpoint, tasksRespZod.parse)
  );
}
